// @flow
import React, { type Node } from "react";
import { theme } from "@nested/ui";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { type ApolloClient, ApolloProvider } from "@apollo/react-hooks";
import { createApolloClient } from "@nested/utils";
import { CookiesProvider } from "react-cookie";
import { ProgressProvider } from "./containers/ProgressContext/ProgressContext";

type Props = {
  children: Node,
  store: ReduxStore,
  client?: ApolloClient<any>,
};

export const Providers = ({
  client = createApolloClient(),
  children,
  store,
}: Props) => (
  <ApolloProvider client={client}>
    <Provider store={store}>
      <ProgressProvider>
        <ThemeProvider theme={theme}>
          <CookiesProvider>{children}</CookiesProvider>
        </ThemeProvider>
      </ProgressProvider>
    </Provider>
  </ApolloProvider>
);
